import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import { Pane, Spinner } from 'evergreen-ui';
import Login from './components/Login';
import Navbar from './components/Navbar';
import Signup from './components/Signup';
import Projects from './components/Projects';
import ProtectedRoute from './components/ProtectedRoute';
import { ProjectProvider } from './context/ProjectContext';
import { UserProvider } from './context/UserContext';
import Graph from './components/Graph/Graph';
import Workers from './components/Workers';
import Tasks from './components/Tasks';
import Profile from './components/Profile';
import Results from './components/Results';
import NoteEditor from './components/Notes/NoteEditor';
import FileUpload from './components/FileUpload';
import Dashboard from './components/Dashboard';
import Report from './components/Report';
import CreateFinding from './components/CreateFinding';
import Scope from './components/Scope';
import CoverageMap from './components/CoverageMap';
import ProjectMembers from './components/ProjectMembers';
import AcceptInvite from './components/AcceptInvite';

function App() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <Pane display="flex" alignItems="center" justifyContent="center" height="100vh">
        <Spinner />
      </Pane>
    );
  }

  return (
      <Router>
        <UserProvider>
        <ProjectProvider>
          {isAuthenticated && <Navbar />}
          <Pane marginTop={isAuthenticated ? 64 : 0}>
          <Routes>
            {/* Public routes */}
            <Route path="/login" element={
              isAuthenticated ? <Navigate to="/dashboard" replace /> : <Login />
            } />
            <Route path="/signup" element={
              isAuthenticated ? <Navigate to="/dashboard" replace /> : <Signup />
            } />

            {/* Protected routes */}
            <Route path="/graph" element={
              <ProtectedRoute>
                <Graph />
              </ProtectedRoute>
            } />
            <Route path="/workers" element={
              <ProtectedRoute>
                <Workers />
              </ProtectedRoute>
            } />
            <Route path="/notes" element={
              <ProtectedRoute>
                <NoteEditor />
              </ProtectedRoute>
            } />
            <Route path="/projects" element={
              <ProtectedRoute>
                <Projects />
              </ProtectedRoute>
            } />
            <Route path="/results" element={
              <ProtectedRoute>
                <Results />
              </ProtectedRoute>
            } />
            <Route path="/report" element={
              <ProtectedRoute>
                <Report />
              </ProtectedRoute>
            } />
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } />
            <Route path="/tasks" element={
              <ProtectedRoute>
                <Tasks />
              </ProtectedRoute>
            } />
            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              }
            />
            <Route path="/upload" element={
              <ProtectedRoute>
                <FileUpload />
              </ProtectedRoute>
            } />
            <Route path="/create-finding" element={
              <ProtectedRoute>
                <CreateFinding />
              </ProtectedRoute>
            } />
            <Route path="/scope" element={
              <ProtectedRoute>
                <Scope />
              </ProtectedRoute>
            } />
            <Route path="/coverage" element={
              <ProtectedRoute>
                <CoverageMap />
              </ProtectedRoute>
            } />
            <Route path="/members" element={
              <ProtectedRoute>
                <ProjectMembers />
              </ProtectedRoute>
            } />
            <Route path="/invite/:token" element={
              <ProtectedRoute>
                <AcceptInvite />
              </ProtectedRoute>
            } />

            {/* Redirect routes */}
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="*" element={<Navigate to={isAuthenticated ? "/dashboard" : "/login"} replace />} />
          </Routes>
        </Pane>
        </ProjectProvider>
        </UserProvider>
      </Router>
  );
}

export default App;
